import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddee8b70"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "icons" }
const _hoisted_3 = { class: "cnk" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "price" }
const _hoisted_7 = {
  key: 0,
  class: "col-auto d-flex align-items-center flex-row"
}
const _hoisted_8 = { class: "current-price fw-600 pe-2" }
const _hoisted_9 = ["data-bs-toggle", "data-bs-title"]
const _hoisted_10 = {
  key: 0,
  class: "mas info-icon-small"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "old-price text-decoration-line-through" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["data-bs-toggle", "data-bs-title"]
const _hoisted_15 = {
  key: 0,
  class: "mas info-icon-small"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "discount" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = {
  key: 0,
  class: "customer_sort"
}
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1" }, "swap_vertical_circle", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas custom_sort_unavailable" }, "swap_vertical_circle", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 3,
  class: "btn btn-sm bg-white drag-handle"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "open_with", -1))
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemIcons = _resolveComponent("ItemIcons")!
  const _component_base_move_buttons = _resolveComponent("base-move-buttons")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", null, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: _ctx.product.main_image_url,
          alt: _ctx.product.product.product_info.name,
          style: {"width":"50px","height":"50px"}
        }, null, 8, _hoisted_1)
      ])
    ]),
    _createElementVNode("td", _hoisted_2, [
      _createVNode(_component_ItemIcons, {
        product: _ctx.product.product
      }, null, 8, ["product"])
    ]),
    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.product.product.product_info.cnk_code ?? _ctx.product.product.product_info.customer_cnk_code), 1),
    _createElementVNode("td", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-link text-start text-decoration-none text-black lh-1 p-0",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openProductDetail && _ctx.openProductDetail(...args)), ["prevent"]))
        }, _toDisplayString(_ctx.product.product.product_info.name), 1)
      ])
    ]),
    _createElementVNode("td", _hoisted_6, [
      ((_ctx.product.product.product_price?.discount_percentage ?? 0 > 0) || (_ctx.product.product.product_price?.discount_value_with_vat ?? 0 > 0))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.priceClass),
                "data-bs-toggle": _ctx.tooltip ? 'tooltip' : null,
                "data-bs-title": _ctx.tooltip
              }, [
                _createTextVNode(" € "),
                (!_ctx.productPrice)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_10, "info"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.productPrice), 1))
              ], 10, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_12, " € " + _toDisplayString(_ctx.product.product.product_price.standard_price_with_vat), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.priceClass),
              "data-bs-toggle": _ctx.tooltip ? 'tooltip' : null,
              "data-bs-title": _ctx.tooltip
            }, [
              _createTextVNode(" € "),
              (!_ctx.productPrice)
                ? (_openBlock(), _createElementBlock("i", _hoisted_15, "info"))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.productPrice), 1))
            ], 10, _hoisted_14)
          ]))
    ]),
    _createElementVNode("td", _hoisted_17, [
      _createElementVNode("div", {
        innerHTML: _ctx.product.product.discount?.label?.content ?? ''
      }, null, 8, _hoisted_18)
    ]),
    (_ctx.AbilityContext.isAuthorizedForFeature('ADVANCED_MGMT_CUSTOMER_CATALOG_PRODUCTS'))
      ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_ctx.product.product.customer_product_sort_weight)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-sm btn-link text-primary ms-1",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteSortWeight && _ctx.deleteSortWeight(...args)), ["prevent"]))
                }, _hoisted_22))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-sm btn-link text-primary ms-1",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addSortWeight && _ctx.addSortWeight(...args)), ["prevent"]))
                }, _hoisted_24)),
            (_ctx.onlyProductsWithCustomWeights)
              ? (_openBlock(), _createBlock(_component_base_move_buttons, {
                  key: 2,
                  "only-top-and-bottom": "",
                  onTop: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moveToTop())),
                  onBottom: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moveToBottom()))
                }))
              : _createCommentVNode("", true),
            (_ctx.onlyProductsWithCustomWeights)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _hoisted_27))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}